import {useEffect} from "react"

interface CommonRoomUser {
	email: string
	name?: string
}

const COMMON_ROOM_SITE_ID = "ccc5b0ba-731e-4b45-bc77-0b2afcd4ef33"

const useCommonRoom = (shouldInitialize = false) => {
	useEffect(() => {
		try {
			if (!shouldInitialize) {
				return
			}

			if (typeof window === "undefined") {
				return
			}

			if (typeof window.signals !== "undefined") {
				return
			}

			const script = document.createElement("script")
			script.src = `https://cdn.cr-relay.com/v1/site/${COMMON_ROOM_SITE_ID}/signals.js`
			script.async = true
			script.onerror = () => {
				console.log("Failed to load Common Room tracking script")
			}

			window.signals = Object.assign(
				[],
				["page", "identify", "form", "track"].reduce(function (acc: any, method: string) {
					acc[method] = function (...args: any[]) {
						window.signals.push([method, args])
						return window.signals
					}
					return acc
				}, {})
			)

			document.head.appendChild(script)
		} catch (e) {
			console.log("Error initializing Common Room tracking", e)
		}
	}, [shouldInitialize])
}

export const trackCommonRoomEvent = {
	identify: (user: CommonRoomUser) => {
		try {
			if (typeof window !== "undefined" && window.signals) {
				window.signals.identify(user)
			}
		} catch (e) {
			console.log("Error tracking Common Room identify event", e)
		}
	},

	track: (eventName: string, eventData?: any) => {
		try {
			if (typeof window !== "undefined" && window.signals) {
				window.signals.track(eventName, eventData)
			}
		} catch (e) {
			console.log("Error tracking Common Room custom event", e)
		}
	},
}

export default useCommonRoom
